import Vue from 'vue'
import axios from 'axios'
import { Message, Dialog, Loading } from 'element-ui'
// axios 统一配置

const service = axios.create({

  baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/home',

  timeout: 10000, // request timeout

  retry: 2, // 请求出错错误次数限制

  retryDelay: 800000 // 请求出错延迟重新请求时间

})

const CancelToken = axios.CancelToken

var cancel

var toastLoading = null

// request 拦截器

service.interceptors.request.use(config => {
  // 需要显示加载状态的请求

  if (config.isShowLoading) {
    toastLoading = Loading.service({

      forbidClick: true,

      spinner: 'el-icon-loading',

      background: 'rgba(0, 0, 0, 0.7)',

      duration: config.timeout,

      text: config.loadingText || '加载数据中……'

    })
  }



  return config
}, error => {
  // 请求错误执行

  console.log(error) // for debug

  return Promise.reject(error)
})

// respone 拦截器

service.interceptors.response.use(response => {
  const {

    data, config

  } = response

  const code = parseInt(data.code)

  if (config.isShowLoading) {
    toastLoading.close()
  }

  if (code === 0) {
    // 成功返回

    return Promise.resolve(data)
  } else {
    return Promise.reject(data)
  }
}, error => {
  const {

    config, response, request

  } = error

  let isRetry = true // 是否重试

  let message = ''

  if (toastLoading) {
    toastLoading.close()
  }

  // timeout为0时不重复请求

  if (!config || !config.retry || !config.timeout) isRetry = false

  // 请求失败提示

  if (response) {
    console.log('require:', response)

    Message.close()
  } else if (error.message) {
    if (error.message.code) {
      Message(error.message.msg)

      return Promise.reject(error.message.msg)
    } else if (error.message.includes('timeout')) {
      Message('网络请求超时！')
      console.log('网络请求超时！')
    }
  }

  // 请求超时或接口出错时重新请求

  config.__retryCount = config.__retryCount || 0

  if (config.__retryCount >= config.retry) {
    Dialog.alert({ message })

    return Promise.reject(error)
  }

  config.__retryCount += 1

  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve(config)
    }, config.retryDelay || 1000000)
  })

  return backoff.then(config => {
    // config.baseURL = ''

    if (config.data) {
      config.data = JSON.parse(config.data)
    }

    return service(config)
  })
})

const $get = (url, params, config = {}) => {
  return service.get(url, {

    params,

    ...config

  })
}

const $post = (url, data, config = {}) => {
  return service.post(url, data, config)
}

/**

 * 同时发起多个请求时的处理

 * @param arr [fn1(),fn2()]

 */

const $all = (arr) => {
  return service.all(arr).then(

    service.spread((acct, perms) => {

      // 两个请求现在都执行完成

      // console.log(acct,perms)

    })

  )
}

Vue.prototype.$get = $get

Vue.prototype.$post = $post

Vue.prototype.$all = $all

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js